module.exports = __webpack_public_path__ + "03_bob_black.49846f27.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer5/03_bob_black.png
// module id = UTpK
// module chunks = 0